













import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { ICenter } from '@/store/modules/views/center/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class DeletecenterDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private center!: ICenter
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deletecenterDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ลบ',
          action: this.deletecenterAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  private async deletecenterAction() {
    this.loading = true
    try {
      await HttpRequestServiceWithToken.delete(
        `${process.env.VUE_APP_API_URL}/v1/all/center/${this.center._id}`,
        {},
        async () => {
          this.updateSnackbar({txt: 'ลบข้อมูลศูนย์บริการสำเร็จ.', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        },
      )
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
